import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';

/* CON-1934 — the Attachments column on every message list shows the first
 * file as before; when the row has more, this "+N more" chip sits under it.
 * Nothing renders for 0, so a single-file row looks exactly as it did. */

/* How many real files ride behind `first`: blank names, repeats of the first
 * and duplicates do not count. */
export const countAdditionalAttachments = (first, extras) => {
  if (!first || !Array.isArray(extras)) return 0;
  return new Set(extras.filter((name) => name && name !== first)).size;
};

function MoreAttachmentsBadge({ count = 0 }) {
  if (!(Number(count) > 0)) return null;
  return (
    <Chip
      label={`+${count} more`}
      size="small"
      variant="outlined"
      color="primary"
      sx={{
        mt: 0.5, height: 20, fontSize: '0.7rem', fontWeight: 500,
      }}
    />
  );
}

MoreAttachmentsBadge.propTypes = {
  count: PropTypes.number,
};

export default MoreAttachmentsBadge;
